// extracted by css-extract-rspack-plugin
export default {"bottomActions":"JhD7OLH2ZjoaCpPg"};